const events = {
    "summernote.change": "summernoteChange",
    "summernote.image.link.insert": "summernoteImageLinkInsert",
}

export default events